<div [style.display]="(imageOfKazaEnabled || (medias?.length >= maxMedia) || (showProgress && mediaService.files.length) || video) ? 'none' : '' " class="kz-media-upload--select-pictures" [ngClass]="{'kz-media-upload--full': !imageOfKaza, 'drop-area-is-hovered': dragOver, 'kz-media-upload--lite': modeLite}">
  <div *ngIf="showUploadMedia" class="kz-media-upload--select-upload" [ngClass]="{'kz-media-upload--select-upload-with-video': showUploadVideo}" id="kz-media-upload--fileupload-form" kzFileDrop [options]="options" (uploadOutput)="onUploadOutput($event, true)" [uploadInput]="mediaService.uploadInput">
    <div id="kz-media-upload--fileupload-dropzone">
      <input #inputFile id="{{ id }}" name="image" type="file" kzFileSelect [options]="options" (uploadOutput)="onUploadOutput($event, true)" [uploadInput]="mediaService.uploadInput" [multiple]="maxMedia !== 1">
      <label for="{{ id }}">
        <img src="/assets/images/posts/upload.svg" height="31" width="31">
        <span *ngIf="!modeLite" i18n="@@publicationFileUpload">Upload or<br />post your photos</span>
      </label>
    </div>
  </div>

  <div *ngIf="showUploadVideo" class="kz-media-upload--select-upload kz-media-upload--select-upload-video" id="kz-media-upload--videoupload-form" kzFileDrop [options]="optionsVideo" (uploadOutput)="onUploadOutput($event, false, true)" [uploadInput]="mediaService.uploadInput">
    <div id="kz-media-upload--videoupload-dropzone">
      <input #inputVideo id="{{ idVideo }}" name="image" type="file" kzFileSelect [options]="optionsVideo" (uploadOutput)="onUploadOutput($event, false, true)" [uploadInput]="mediaService.uploadInput" [multiple]="false">
      <label for="{{ idVideo }}">
        <img src="/assets/images/posts/video-add.svg" height="31" width="31">
        <span *ngIf="!modeLite" i18n="@@publicationVideoUpload">Upload or<br />post your video</span>
      </label>
    </div>
  </div>

  <span *ngIf="imageOfKaza" (click)="showImageOfKaza()" class="kz-media-upload--select-kaza">
    <img src="/assets/images/posts/upload.svg" height="31" width="31">
    <span *ngIf="!modeLite" i18n="@@publicationKazaPicturePart1">Picture of<br />my Kaza</span>
    <ng-container *ngIf="modeLite"><br><span i18n="@@publicationKazaPicturePart1Small">Of my Kaza</span></ng-container>
  </span>
</div>

<div class="kz-media-upload--mess">
  <ng-container *ngIf="showProgress && mediaService.files.length">
    <app-media-progress [designPro]="this.type == 'proService'"></app-media-progress>
  </ng-container>

  <p *ngIf="showErrorSize && !modeLite" class="img-ul-file-too-large" i18n="@@publicationImgFileTooLarge">An image was too large and was not uploaded. The maximum file size is {{maxFileSize | fileSize}}.</p>
  <p *ngIf="showErrorUpload && !modeLite" class="img-ul-file-too-large" i18n="@@publicationImgFileError">Error occurred</p>
  <p *ngFor="let error of errors?.violations" class="img-ul-file-too-large">
    <span *ngIf="error.propertyPath == 'file' && !modeLite">{{ error.message }}</span>
  </p>
</div>
<app-media-kaza
  *ngIf="imageOfKazaEnabled"
  [kaza]="kaza"
  [maxMedia]="maxMedia"
  [medias]="medias"
  [showMenu]="menuOfKaza"
  (mediasChange)="mediasChange($event)"
  [minWidth]="minWidth"
  [minHeight]="minHeight"
></app-media-kaza>

<p *ngIf="showMaxLimit" class="kz-media-upload--select-pictures--complete" [style.display]="(medias?.length < maxMedia || imageOfKazaEnabled) ? 'none' : ''">
  <span i18n="@@publicationSelectPicturesComplete">You have reached the maximum number of photos</span>
</p>
